import React, { useEffect, useState } from 'react';
import {
  Box,
  Stack,
  Typography,
  Button
} from "@mui/material";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Empty from "../../assets/icons/Empty";
import CircularProgress from "../../components/form/CircularProgress";
import Layout from "../../components/layout/Layout";
import MapTrack from "../../components/map/MapTrack";
import { useCanView } from "../../config/hook/UserPermissions";
import { Alert } from '../../components/form';
import Notification from "../../components/form/Notification";

import {
  cleanLastRoute,
  getAllOnRoutes,
  getByLastRoute,
  getIdOnRoutes,
  cleanDetailRoute
} from "../../store/transactions/thunk/home";

const IsEmpty = ({ loading, empty, textEmpty, textDetail }) => {
  return (
    <div className={`flex flex-col ${empty ? "flex-1" : "flex-0"}`}>
      {loading &&
        <Box sx={{
          display: 'flex',
          height: "100%",
          width: '100%',
          justifyContent: "center",
          alignItems: "center"
        }}>
          <CircularProgress />
        </Box>
      }
      {(empty && !loading) &&
        <Box sx={{
          display: 'flex',
          flexDirection: "column",
          height: "100%",
          width: '100%',
          justifyContent: "center",
          alignItems: "center"
        }}>
          <Empty />

          <Stack justifyContent="center" alignItems="center" spacing={1} pt={2} >
            <Typography variant="bml">{textEmpty}</Typography>
            <Typography variant="caption">{textDetail}</Typography>
          </Stack>
        </Box>
      }
    </div>
  )
}

const IsLoading = ({ loading }) => {
  return (
    <div className="absolute inset-0 flex justify-end items-start" style={{ marginTop: '10px', marginRight: '5%' }}>
      {loading && <CircularProgress className=" relative z-50" />}
    </div>
  )
}


const Home = () => {
  const [__] = useTranslation("global");
  const dispatch = useDispatch();

  const [r__] = useTranslation("order");
  const canView = useCanView();
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })

  const [active, setActive] = useState(false);
  const [open, setOpen] = useState(false);
  const [token, setToken] = useState(null)
  const home = useSelector(state => state.transactions.home);
  const [preserveViewport, setPreserveViewport] = useState(false)
  const [showLoading, setShowLoading] = useState(false)

  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })

  const getData = ({ page }) => {
    dispatch(cleanLastRoute())
    dispatch(cleanDetailRoute())
    dispatch(getAllOnRoutes())
  }

  useEffect(() => {
    getData({ page: 1 })
  }, [dispatch])

  const saveLink = () => {
    const enlace = `${window.location.origin}/tracking/${token}`
    const tempInput = document.createElement('input');
    tempInput.value = enlace;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
  
    setShowNoti({ open: true, msg: "", variant: "success", action: "clipboard" })

  }

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
  }

  useEffect(() => {
    let _params = get(home.detail, "data", []);

    const interval = setInterval(() => {
      if (_params) {
        if (_params.idRouteStatus == 4 && showLoading) {
          dispatch(getIdOnRoutes({ id: _params.token }))
          dispatch(getByLastRoute({ id: _params.token }))
          setShowLoading(true)
          setPreserveViewport(true)
        }
      } else {
        dispatch(cleanLastRoute())
        dispatch(cleanDetailRoute())
        setToken(null)
        setShowLoading(false)
      }
    }, 30000);
    return () => clearInterval(interval)
  }, [dispatch, home])


  const setNewActive = (e) => {
    if (e) {
      let { token } = e
      dispatch(cleanDetailRoute())
      dispatch(getIdOnRoutes({ id: token }))
      dispatch(getByLastRoute({ id: token }))
      setToken(token)
      setShowLoading(true)
    }
  }

  useEffect(() => {
    if (!token) return;
    const last = get(home, 'last', {});
    if (last.isSuccess && !last.data) {
      setAlert({
        open: true,
        title: "Sin tracking disponible",
        subtitle: "La ruta fue iniciada desde la web, no tiene tracking del conductor.",
        type: "error",
        btn: "Cerrar",
        func: closeAlert
      });
    }
  }, [get(home, 'last.isSuccess'), token])

  return (
    <Layout disableHead={true}>
      <div>

        <div className="absolute z-[1] h-full flex flex-row max-h-screen" onMouseOver={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
          <div id="main-menu" className='relative w-[300px] border-r-gray-400 border-r-[1px] min-h-screen h-full bg-white overflow-y-auto flex flex-col'>
            <div className='sticky top-0 z-[1] flex flex-row justify-between border-b-gray-400 border-b-[1px] p-[20px] bg-white'>
              <div className='uppercase'>{__("dashboard.title")}</div>
              <div>{get(home, "data", []).length}</div>
            </div>
            <IsEmpty loading={get(home, "isLoading", false)} empty={isEmpty(get(home, "data", []))} textEmpty={__("dashboard.empty.main")} textDetail={__("dashboard.empty.detail")} />
            <ul role="list" className={`divide-y divide-gray-400 border-b-gray-400 border-b-[1px] flex flex-col ${isEmpty(active?.orders) ? "flex-0" : "flex-1"}`}>
              {map(get(home, "data", []), (route) => (
                <li
                  key={route.idRoute}
                  role="button"
                  onClick={() => {
                    if (canView("INICIO/DETALLE RUTA", "watch")) {
                      setNewActive(route)
                    } else {
                      setAlert({
                        open: true,
                        title: "Permiso Denegado.",
                        subtitle: (<ul> • No tienes permiso para ver el detalle de la ruta.</ul>),
                        type: "error",
                        btn: __(`${module}.actions.close`),
                        func: closeAlert
                      })
                    }
                  }}
                  className={`flex justify-between items-center gap-x-6 py-5 ${active.idRoute === route.idRoute ? "bg-gray-100" : "bg-[transparent]"} hover:bg-gray-100 active:bg-[#0000004a] p-[20px] duration-300 cursor-pointer `}
                >
                  <div className="flex min-w-0 w-full max-w-full">
                    <svg className='w-12 h-12 flex-none rounded-full bg-gray-50' viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect className={`${active.idRoute === route.idRoute ? "fill-[#B0E2FA]" : "fill-[#DFE7F3]"} h-[44px] w-[44px]`} rx="22" fill="#B0E2FA" />
                      <g clipPath="url(#clip0_824_89124)">
                        <path className={`${active.idRoute === route.idRoute ? "fill-[#0C709F]" : "fill-[#556C8F]"}`} d="M28.75 13.9395L14.07 20.0795C13.24 20.4295 13.26 21.6095 14.09 21.9295L19.43 23.9995C19.69 24.0995 19.9 24.3095 20 24.5695L22.06 29.8995C22.38 30.7395 23.57 30.7595 23.92 29.9295L30.07 15.2595C30.4 14.4295 29.57 13.5995 28.75 13.9395Z" />
                      </g>
                      <defs>
                        <clipPath id="clip0_824_89124">
                          <rect width="24" height="24" fill="white" transform="translate(10 10)" />
                        </clipPath>
                      </defs>
                    </svg>

                    <div className="min-w-0 flex-auto pl-[10px]">
                      <p className="text-sm font-semibold leading-6 text-gray-900">#:&nbsp;{route.idRoute}</p>
                      <p className="mt-1 truncate text-xs leading-5 text-gray-500">{route.routeName}</p>
                    </div>
                    <div className={`flex items-center justify-end pl-[10px]`}>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={`w-[15px] h-[15px] ${active.idRoute === route.idRoute ? "-rotate-180" : "rotate-0"} duration-500`}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                      </svg>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

        </div>
        <div className='h-screen w-full pl-[300px]'>
          <IsLoading loading={showLoading} />
          <div className="absolute inset-0 flex justify-center items-start" style={{ marginTop: '10px', marginLeft: '40%' }}>

            <Button
              className=" relative z-50"
              variant="contained"
              color="secondary"
              onClick={() => {
                if (canView("INICIO/DETALLE RUTA/COMPARTIR", "watch")) {
                  saveLink();
                } else {
                  setAlert({
                    open: true,
                    title: "Permiso Denegado.",
                    subtitle: (<ul> • No tienes permiso para compartir el link de la ruta.</ul>),
                    type: "error",
                    btn: __(`${module}.actions.close`),
                    func: closeAlert
                  })
                }
              }}
              disabled={token == null ? true : false}
            >
              {"Compartir Ruta"}
            </Button>
          </div>
          {
            <MapTrack
              driverPosition={token != null ? get(home, 'last.data', null) : null}
              locationSuggestions={token != null ? get(home, "detail.data.viewRouteDeliveryPoints", []) : []}
              locationsReal={[]}
              preserveViewport={preserveViewport}
            />
          }
        </div>
      </div>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
    </Layout >
  )
}

export default Home

